module.exports = __webpack_public_path__ + "static/assets/95856461e80ec450bdfd8e0586691f69.svg";